const Step = require("app/components/checkout/Step");
const assign = require("object-assign");
const RecipientForm = require('app/components/checkout/steps/recipient/RecipientForm');
const Trans = require('app/components/trans/Trans')

class Recipient extends Step {

	get baseClassName() {
		return super.baseClassName + " step-recipient";
	}

	get gaInfo(){
		return {
			'page_title' : translate('Ser afsenderside'),
			'page_path': translate('/ser-afsenderside/')
		};
	}

	get title() {
		return translate("Leveringsdetaljer");
	}

	get description() {
		return (
          <span><Trans> Kontroller & bekræft leveringsadresse </Trans> </span>
		);
	}

	constructor(props) {
		super(props);

		this.state = assign({}, this.state, {
			shouldRenderNextButton: true
		});
	}

	_changeNextButtonState = (state) => {
		this.setState({shouldRenderNextButton: state});
	};

	submit() {
		return this.formElement.submit();
	}

	setWarning(input){
		if(typeof(this.props.setWarning) === "function"){
			this.props.setWarning(input);
		}
	}

	renderStep() {
		return (
			<RecipientForm setWarning={(input) => this.setWarning(input)} ref={el => this.formElement = el} cart={this.cart} pipelines={this.pipelines}/>
		);
	}

}

module.exports = Recipient;
